import Dropdown from '~/components/CasesDropdown.vue';
export default {
  __name: 'ShareDropdown',
  props: {
    placement: {
      type: String,
      default: 'bottom'
    },
    modalName: {
      type: String,
      default: 'share'
    },
    url: {
      type: String
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var shareUrl = computed(function () {
      if (props.url) return props.url;
      return window ? window.location.href : '';
    });
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var copyToClipboabd = useCopyToClipboard;
    function copyUrl() {
      useCopyToClipboard(shareUrl.value, $i18n.t('toast.linkCopied'));
    }
    return {
      __sfc: true,
      props: props,
      shareUrl: shareUrl,
      $i18n: $i18n,
      copyToClipboabd: copyToClipboabd,
      copyUrl: copyUrl,
      Dropdown: Dropdown
    };
  }
};